import Dashboard from "pages/Dashboard";
import Students from "pages/Students";
import Coaches from "pages/Coaches";
import Schools from "pages/Schools";
import Resources from "pages/Resources";
import Programs from "pages/Programs";
import Avatars from "pages/Avatars";
import Groups from "pages/Groups";
import Settings from "pages/Settings";
import FAQs from "pages/FAQ";
import Chatbot from "pages/Chatbot";

import Profile from "pages/Profile";
import PasswordSettings from "pages/PasswordSettings";

import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import ResetPassword from "pages/Authentication/ResetPassword";
import Pages404 from "pages/Authentication/Pages404";
import Offline from "pages/Authentication/Offline";


interface RouteObject {
  path: string;
  component: React.ComponentType<any>; 
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  { path: "/", component: Dashboard },
  { path: "/dashboard", component: Dashboard },
  { path: "/students", component: Students },
  { path: "/coaches", component: Coaches },
  { path: "/schools", component: Schools },
  { path: "/resources", component: Resources },
  { path: "/programs", component: Programs },
  { path: "/avatars", component: Avatars },
  { path: "/groups", component: Groups },

  { path: "/hope", component: Chatbot },
  { path: "/faqs", component: FAQs },
  { path: "/settings", component: Settings },


  { path: "/profile", component: Profile },
  { path: "/password-settings", component: PasswordSettings },
];

const publicRoutes = [
  
  { path: "/reset-password", component: ResetPassword },

  { path: "/offline", component: Offline },
  { path: "/404", component: Pages404 },

  { path: "/login", component: Login },
  { path: "/logout", component: Logout },

]

export { authProtectedRoutes, publicRoutes };
